<template>
  <div>
    <ion-grid style="max-width: 800px;">
      <ion-row style="border-bottom: 1px rgba(0,0,0,0.1) solid; padding: 30px 0; margin-top: 1em;">
        <ion-col size-lg="6" size-md="6" size-sm="6" size-xs="12" style="border-right: 1px solid rgba(0,0,0,0.3);">
          <div style="width: 100%; text-align: center;">
            <div style="display: inline-block;">
              <img style="margin: auto;display: block; float: left;" :class="isSubscribed ? `profile-initial premium` : `profile-initial`" referrerpolicy="no-referrer" :src="profilePic"/>
              <div style="float: right; text-align: left; padding-left: 16px; height: 100%; display: flex; flex-direction: column; justify-content: center; max-width: 270px;">
                <span style="font-weight: 500;">{{ $store.state.user.user.name }}</span>
                <p style="margin: 0;">{{ $store.state.user.user.email }}</p>
              </div>
            </div>
            <div v-if="$store.state.user.user.subscription.status !== 'inactive'" style="margin-top: 18px;">
              <p style="margin-top: 1em; margin-bottom: 4px;">Subscription</p>
              <p @click="info('premium')" class="subs-profile" style="font-size: 1.3em; font-weight: 700; color: #fcc200;">Lawyerly Premium<ion-icon name="information-circle-outline"></ion-icon></p>
              <p style="margin: 0;">Expires on {{formatDate(subscription.dateEnd)}}</p>
            </div>
            <div v-else style="margin-top: 18px;">
              <p style="margin-top: 1em; margin-bottom: 4px;">Subscription</p>
              <p @click="info()" class="subs-profile" style="font-size: 1.3em; font-weight: 700;">Lawyerly Free<ion-icon name="information-circle-outline"></ion-icon></p>
              <p style="margin: 0;">Limited to 300 cases</p>
            </div>
          </div>
        </ion-col>
         <ion-col style="text-align: center;" size-lg="6" size-md="6" size-sm="6" size-xs="12">
          <b style="margin-bottom: 20px; display: inline-block;">Stats</b>
          <ion-row>
            <ion-col style="text-align: center;" size-lg="4" size-md="4" size-sm="4">
              <ion-label style="font-size: 1.75em;">{{annotations.annotations}}</ion-label>
              <p position="fixed">Annotations</p>
            </ion-col>
            <ion-col style="text-align: center;" size-lg="4" size-md="4" size-sm="4">
              <ion-label style="font-size: 1.75em;">{{annotations.digests}}</ion-label>
              <p position="fixed">Digests</p>
            </ion-col>
            <ion-col style="text-align: center;" size-lg="4" size-md="4" size-sm="4">
              <ion-label style="font-size: 1.75em;">{{annotations.notebooks}}</ion-label>
              <p position="fixed">Notebooks</p>
            </ion-col>
          </ion-row>
       </ion-col>
      </ion-row>
     <ion-row style="border-bottom: 1px rgba(0,0,0,0.1) solid; margin-bottom: 0.5em; padding: 30px 0;">
      <ion-col size-lg="6" size-md="6" size-sm="12" size-xs="12" style="border-right: 1px solid rgba(0,0,0,0.3);">
          <div style="text-align: center; padding: 0 20px;">
            <div><img style="display: inline-block; vertical-align: middle; height: 32px;" src="coin.png" /><span style="font-size: 32px; margin: 0 0 0 8px; display: inline-block; vertical-align: middle;">0</span></div>
            <h6 style="margin: 0;">Available Bitesize Coins</h6>
            <span style="margin-top: 6px; display: block;">Redeem rewards, prizes and entry to events using your Bitesize Coins.</span>
          </div>
        </ion-col>
        <ion-col size-lg="6" size-md="6" size-sm="12" size-xs="12">
          <div style="text-align: center; padding: 0 20px;">
            <h6>Refer friends and earn Bitesize Coins</h6>
            <div class="referral-code tooltip"><span>{{$store.state.user.user.referral_code}}</span><span class="icon" v-html="icon('si-entypo-copy')"></span>
            <span class="tooltiptext">Copy Code</span></div>
            <!-- <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce varius varius tempor.</span> -->
          </div>
        </ion-col>
     </ion-row>
      <ion-row>
        <ion-col :size-lg="isUpdatePayment" v-if="(payment.status == 'pending' || payment.status == 'declined')" :size-md="isUpdatePayment" size-sm="6" size-xs="6">
          <div style="width: 100%;">
            <ion-button class="profile-button" fill="clear" style="height: auto;" expand="block" @click="updatePayment">
              <div style="padding: 40px 1em;">
                <p style="margin-bottom: 1em;"><svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#18bc9c"><path d="M13 18.9L19.1 12.8L21.2 14.9L15.1 21H13V18.9M21.4 11.3L22.7 12.6C22.9 12.8 22.9 13.1 22.7 13.3L21.7 14.3L19.6 12.3L20.6 11.3C20.7 11.2 20.8 11.1 21 11.1C21.2 11.1 21.3 11.2 21.4 11.3M11 18H4V12H17.1L22 7.1V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H11V18M4 6H20V8H4V6Z"/></svg></p>
                <p style="line-height: 17px;">{{payment.payment.type == 'xendit' ? 'Continue' : 'Update'}}<br/> Payment</p>
                <div class="button notif-badge"></div>
              </div>
            </ion-button>
          </div>
        </ion-col>
        <ion-col :size-lg="isUpdatePayment" :size-md="isUpdatePayment" size-sm="6" size-xs="6">
          <div style="width: 100%;">
             <ion-button class="profile-button" style="height: auto;" fill="clear" expand="block" @click="()=>{open()}">
                <div style="padding: 40px 1em;">
                  <p style="margin-bottom: 1em;">
                    <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#18bc9c"><path d="M16,9H19L14,16M10,9H14L12,17M5,9H8L10,16M15,4H17L19,7H16M11,4H13L14,7H10M7,4H9L8,7H5M6,2L2,8L12,22L22,8L18,2H6Z"/></svg>
                  </p>
                  <p style="line-height: 17px;">Upgrade <br/> Subscription</p>
                </div>
             </ion-button>
          </div>
        </ion-col>
        <ion-col :size-lg="isUpdatePayment" :size-md="isUpdatePayment" size-sm="6" size-xs="6">
          <div style="width: 100%;">
             <ion-button class="profile-button" style="height: auto;" fill="clear" expand="block" @click="$router.push('/features')">
                <div style="padding: 40px 1em;">
                  <p style="margin-bottom: 1em;">
                    <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#18bc9c"><path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M9.5 18L10.2 15.2L8 13.3L10.9 13.1L12 10.4L13.1 13L16 13.2L13.8 15.1L14.5 17.9L12 16.5L9.5 18Z"/></svg>
                  </p>
                  <p style="line-height: 17px;">Premium <br/> Features</p>
                </div>
             </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div v-if="popupContent">
        <div style="background: #fff;">
          <div id="popupMenu" style="display:none">
              <div class="sub-popup">
                <p>Choose one of our plans:</p>
                <ion-row class="sub-buttons">
                  <ion-col v-for="p in plans" :key="p.label" size-md="4" size-lg="4" size-xs="12" justify-center>
                    <button @click="select(p.type)">
                      <div>
                        <h3 v-html="p.label"></h3>
                        <h4>&#8369; {{p.price}}</h4>
                      </div>
                    </button>
                  </ion-col>
                </ion-row>
              </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import config from '../../config';
import {format} from 'date-fns';
import Icons from "../../components/annot8/icons";
import { firebase as $firebase } from "@/firebase";

export default {
  data() {
    return {
      toastTimeout: 2000,
      annotations: {annotations: 0, digests: 0, notebooks: 0},
      subscription: {
        status: 'inactive',
        dateEnd: null
      },
      payment: {
        payment: {
          type: ''
        }
      },
      popupContent: false,
      plans: this.$config.plans,
    };
  },

  computed: {
    isGoogleLinked() {
      try {
        return (
          this.$store.state.user.user.auth.firebase.identities["google.com"]
            .length > 0
        );
      } catch (err) {
        return false;
      }
    },

    isFacebookLinked() {
      try {
        return (
          this.$store.state.user.user.auth.firebase.identities["facebook.com"]
            .length > 0
        );
      } catch (err) {
        return false;
      }
    },
    subscriptionLabel() {
      if(this.subscription.type) {
        return this.subscription.type_.label.replace("<br/>", " ").replace("Free", "");
      }
      return "Free";
    },
    isUpdatePayment() {
      if(this.payment.status == 'pending' || this.payment.status == 'declined') {
        return 4;
      }
      return 6;
    },
    encodedCode() {
      var encodedString = btoa( this.$store.state.user.user.email);
      var trimmedString = encodedString.substring(0, 6);
      return trimmedString;
    },
    profilePic() {
      if(this.$store.state.user.user.auth) {
        if(this.$store.state.user.user.auth.picture) {
          return this.$store.state.user.user.auth.picture;
        }
      }
      return `https://ui-avatars.com/api/?length=1&name=${this.$store.state.user.user.name}&bold=true&rounded=true&background=3498DB&color=ffffff&font-size=0.60&size=32`
    },
    isSubscribed() {
      if(!this.$store.state.user.user.subscription) {
        return false;
      }
      return this.$store.state.user.user.subscription.status == 'active';
    }
  },

  methods: {
    icon(btn) {
      // return '<div style="display:block">' + Icons[btn.icon.replace("#", "")]
      //    + (btn.label ? '<div class="annot8-btn-label">' + btn.label + '</div>' : '')
      //    + '</div>';
      return Icons[btn];
    },
    async checkRedirect() {

      /* verify token */
      await $firebase
        .auth()
        .getRedirectResult()
        .then(async res => {
          if (res.credential) {

            // Accounts successfully linked.
            var credential = res.credential;
            var user = res.user;
            this.$ionic.showToast("Account linked", {
              duration: this.toastTimeout
            });
          }
        })
        .catch(error => {
          if (!error) {
            return;
          }
          // Handle Errors here.
          // var errorCode = error.code
          var errorMessage = error.message;
          this.$ionic.showToast(errorMessage, { timeout: this.toastTimeout });
        });
    },

    back() {
      this.$router.go(-1);
    },

    _socialLink(provider) {
      $firebase
        .auth()
        .currentUser.linkWithRedirect(provider)
        .catch(error => {
          if (!error) {
            return;
          }
          // Handle Errors here.
          // var errorCode = error.code
          var errorMessage = error.message;
          this.$ionic.showToast(errorMessage, { timeout: this.toastTimeout });
        });
    },

    ggLink() {
      this._socialLink(new this.$firebase.auth.GoogleAuthProvider());
    },

    updatePayment() {
      if(this.payment.payment.type == 'voucher') {
        this.$router.push('/payment-update');
      } else {
        const url = this.payment.payment.xendit.invoice_url;
        const cordova = window.cordova;
        if(cordova === undefined) {
            window.location.href = url;
        } else {
            var conf = "location=yes,zoom=no,hideurlbar=yes,hidenavigationbuttons=yes,toolbarcolor=#17b391,beforeload=get,closebuttoncolor=#ffffff";
            var ref = cordova.InAppBrowser.open(url, "_blank", conf);

            ref.addEventListener("exit", () => {
                this.$router.push('/payment-done/error');
            });

            ref.addEventListener("beforeload", (params, callback) =>{
                callback(params.url);

                if(params.url.includes('success')) {
                  ref.addEventListener("exit", () => {
                    this.$router.push('/payment-done/success');
                  });
                }

                if(params.url.includes('failed')) {
                  ref.addEventListener("exit", () => {
                    this.$router.push('/payment-done/failed');
                  });
                }

                if (params.url.startsWith(this.$config.subscription.url)) {
                  setTimeout(()=>{
                    ref.close();
                  }, 2000);
                }
            });
        }
      }
    },

    fbLink() {
      this._socialLink(new this.$firebase.auth.FacebookAuthProvider());
    },

    async getAnnotationsCount() {
      const res = await this.$lawyerly.annotations.countAnnotations({userid: this.$store.state.user.user.id});
      if(res) {
        if(res.data) {
          if(res.data.cases) {
            this.annotations = res.data;
          }
        }
      }
    },

    async getSubscription() {
      const res = await this.$http({
        method: "GET",
        url: config.api.url + "/subscribe/active",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      if(res) {
        if(res.data) {
            this.subscription = res.data;
            // this.$store.commit("user/setSubscription", res.data);
          } else {
            this.subscription = {status: 'inactive'};
        }
      }
    },

    async getPayment() {
      const res = await this.$http({
        method: "GET",
        url: config.api.url + "/subscribe/payment",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      if(res) {
        if(res.data) {
          if(res.data.length > 0) {
            this.payment = res.data[0];
          }
        }
      }
    },

    formatDate(date) {
      if(date) {
        return format(new Date(date), 'MMM. dd, yyyy');
      }

      return format(new Date(), 'MMM. dd, yyyy');
    },

    open(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          cssClass: "mobile-wide-width-popup",
          translucent: true
        });
      }, 200);
    },

    select(type) {
        this.$ionic.dismissPopover();
        this.$router.push("/payment/"+type);
    },

    async info(type = "free") {
      let t = `<div>You can still digest <b>${300 - this.$store.state.user.user.annotations}</b> cases under the Free Lawyerly subscription. Subscribe now to Lawyerly Premium to enjoy unlimited case digests.</div>`;

      if(type == 'premium') {
        t = `<div>You are currently subscribed to Lawyerly Premium. Enjoy Lawyerly with unlimited case digests.
        <p style="margin-top: 1em; text-align: center;">Subscription Period</p>
        <p style="font-weight: 700; text-align: center;">${this.formatDate(this.subscription.dateStart)} - ${this.formatDate(this.subscription.dateEnd)}</p>
        </div>`;
      }

      await this.$ionic.showAlert(t,
        {
          cssClass: "medium-width-alert",
          header: "Subscription",
          buttons: [
            "Close"
          ]
        }
      );
    },
    togglePremium(e) {
      if(this.$store.state.user.user.subscription.status == 'active') {
        this.subscription = {...this.subscription, status: 'inactive'};
        this.$store.commit("user/setPremium", 'inactive');
      } else {
        this.subscription =  {...this.subscription, status: 'active'};
        this.$store.commit("user/setPremium", 'active');
      }
    }
  },

  mounted() {
    this.checkRedirect();
    this.getAnnotationsCount();
    this.getSubscription();
    this.getPayment();
  }
}
</script>

<style lang="scss" scoped>
.login-content {
  --background: #f0f0f0;
  --color: #505050;
}
.center-content {
  text-align: center;
}

.login-box ion-list,
.login-box ion-item {
  background: transparent;
  --background: transparent;
}

.sub-popup {
    padding: 1.25em 1em;
    width: 100%;
  }

  .sub-buttons {
    display: flex;
    width: 100%;
  }

  .sub-buttons ion-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  .sub-buttons button:before{
    content:'';
    float:left;
    padding-top:100%;
  }

  .sub-buttons button div{
   height: 100%;
  }

  .sub-buttons button {
    margin: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--ion-color-primary);
    max-width: 200px;
  }

  .sub-buttons button div h3, .sub-buttons button div h4 {
    color: #ffffff;
    margin: 0 0 5px 0;
  }

  .sub-buttons button div h4 {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .subs-profile:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .subs-profile ion-icon {
    vertical-align: -3px;
    margin-left: 5px;
  }

  @media (min-width: 800px) {
    .sub-buttons button {
      margin: 4px;
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--ion-color-primary);
      max-width: none;
    }
  }

  .button.notif-badge {
    position: absolute;
    top: 45px;
    right: 96px;
    height: 10px;
    width: 10px;
  }

  .profile-button:hover {
    background: rgba(24, 188, 156, 0.1);
  }

  .referral-code {
    max-width: 200px;
  }
</style>
